import gql from "graphql-tag";
import { useQuery } from "react-query";
import doRequest from "../utils/doRequest";

const getUser = gql`
  query GetUser($userId: Int) {
    getUser(userId: $userId) {
      id
      userName
      firstName
      lastName
      domain
      email
      phone
      description
      languageCode
      image
      gender
      type
      birthDate
      country
    }
  }
`;

export function useGetUser(userId) {
  let variables = {};

  if (userId) {
    variables = {
      userId,
    };
  }

  return useQuery(
    ["getUser", { userId }],
    async () => {
      return doRequest(
        {
          query: getUser,
          variables,
        },
        "data.getUser"
      );
    },
    {
      retry: 1,
      cacheTime: 60 * 60 * 1000, // let's cache this for an hour
      refetchOnWindowFocus: false,
    }
  );
}
